import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[customBadgeHtmlContent]',
})
export class CustomBadgeHtmlContentDirective
  implements AfterViewInit, OnChanges, OnDestroy
{
  @Input('customHtmlContent') htmlContent?: string;

  private readonly MAX_RETRIES = 3;
  private retryCount = 0;
  private pendingTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor(private host: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.retryCount = 0;
    this.updateContent();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['htmlContent']) {
      this.retryCount = 0;
      this.updateContent();
    }
  }

  ngOnDestroy(): void {
    if (this.pendingTimeout) {
      clearTimeout(this.pendingTimeout);
    }
  }

  private updateContent(): void {
    const root =
      this.host.nativeElement.querySelector('goa-badge')?.shadowRoot ?? null;

    if (!root) {
      if (this.retryCount < this.MAX_RETRIES) {
        this.retryCount++;
        this.pendingTimeout = setTimeout(() => this.updateContent(), 50);
      }
      return;
    }

    const content = root.querySelector(
      'div.goa-badge-content'
    ) as HTMLElement | null;

    if (!content) {
      if (this.retryCount < this.MAX_RETRIES) {
        this.retryCount++;
        this.pendingTimeout = setTimeout(() => this.updateContent(), 50);
      }
      return;
    }

    if (this.htmlContent && content.innerHTML !== this.htmlContent) {
      content.innerHTML = this.htmlContent;
    }
  }
}
